'use client';
import { clsx } from 'clsx';
import { usePathname } from 'next/navigation';
import { MenuLink } from 'components/UI/Menu';
import type { MenuItemProps } from 'types/menu';
import styles from './Pills.module.scss';

const Pills = ({
  items,
  className = '',
  disableActiveState = false,
}: {
  items: Array<MenuItemProps>;
  className?: string;
  disableActiveState?: boolean;
}) => {
  const pathname = usePathname();

  return (
    <>
      {items.map((item) => {
        const destination = item.url ? new URL(item.url) : { pathname: '' };

        return (
          <MenuLink
            key={item.title}
            menuItem={item}
            className={clsx(
              styles.pill,
              { [styles.active]: !disableActiveState && destination.pathname === pathname },
              className
            )}
          />
        );
      })}
    </>
  );
};

export default Pills;
